@mixin itemStyling {
  @apply text-color-3
    relative
    flex
    flex-grow
    cursor-pointer
    items-center
    no-underline
    duration-150
    ease-in-out;
}

:host {
  @apply relative
    flex
    flex-grow
    items-center
    focus-base;
}

.container {
  @include itemStyling;
  @apply text-start;

  & a {
    @include itemStyling;
    @apply focus-base;
  }
}

.dropdown-item-content {
  @apply flex-auto py-0.5;
}

// item icon
.dropdown-item-icon {
  @apply relative
    opacity-0
    duration-150
    ease-in-out;
  transform: scale(0.9);
}

:host([scale="s"]) {
  .container {
    @apply text-n2h py-1 px-2;
  }

  .dropdown-item-icon,
  .dropdown-item-icon--start {
    padding-inline-end: var(--calcite-spacing-sm);
  }

  .dropdown-item-icon--end {
    padding-inline-start: var(--calcite-spacing-sm);
  }
}

:host([scale="m"]) {
  .container {
    @apply text-n1h py-2 px-3;
  }

  .dropdown-item-icon,
  .dropdown-item-icon--start {
    padding-inline-end: var(--calcite-spacing-md);
  }

  .dropdown-item-icon--end {
    padding-inline-start: var(--calcite-spacing-md);
  }
}

:host([scale="l"]) {
  .container {
    @apply text-0h py-2.5 px-4;
  }

  .dropdown-item-icon,
  .dropdown-item-icon--start {
    padding-inline-end: var(--calcite-spacing-xl);
  }

  .dropdown-item-icon--end {
    padding-inline-start: var(--calcite-spacing-xl);
  }
}

//focus
:host(:focus) {
  @apply focus-inset outline-none;

  .container {
    @apply text-color-1 no-underline;
  }
}

:host(:hover:not([disabled])),
:host(:active:not([disabled])) {
  .container {
    @apply bg-foreground-2 text-color-1 no-underline;
  }

  .dropdown-link {
    @apply text-color-1;
  }
}

:host(:active:not([disabled])) .container {
  @apply bg-foreground-3;
}

:host([selected]) .container:not(.container--none-selection),
:host([selected]) .dropdown-link {
  @apply text-color-1 font-medium;
  & calcite-icon {
    color: theme("backgroundColor.brand");
  }
}

:host(:hover:not([disabled])) .dropdown-item-icon {
  color: theme("borderColor.color.1");
  @apply opacity-100;
}

:host([selected]) .dropdown-item-icon {
  color: theme("backgroundColor.brand");
  @apply opacity-100;
}

@include base-component();
@include disabled();
